import MuiCard from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import CardContent from '@mui/material/CardContent'
import { node, shape, string } from 'prop-types'
import { forwardRef } from 'react'
import Link from '../../molecules/link'
import ConditionalWrapper from '../../particles/conditional-wrapper'
import { CardActionsStyled, CardContentStyled, CardStyled } from './card.styled'

const CardHeader = ({ header, href }) => {
	return header ? (
		<ConditionalWrapper condition={!!href} wrapper={(children) => <Link href={href}>{children}</Link>}>
			{header}
		</ConditionalWrapper>
	) : null
}

const Card = forwardRef(({ cardContentProps, cardActionsProps, header, content, actions, href, ...props }, ref) => {
	return (
		<CardStyled ref={ref} {...props}>
			<CardHeader header={header} href={href} />
			<CardContentStyled {...cardContentProps}>{content}</CardContentStyled>
			{actions && <CardActionsStyled {...cardActionsProps}>{actions}</CardActionsStyled>}
		</CardStyled>
	)
})

Card.displayName = 'Card'

Card.defaultProps = {
	...MuiCard.defaultProps,
}

Card.propTypes = {
	...MuiCard.propTypes,
	cardContentProps: shape(CardContent.propTypes),
	cardActionsProps: shape(CardActions.propTypes),
	header: node,
	content: node,
	actions: node,
	href: string,
}

export default Card
